import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { JwtUser } from '@models/authentication/jwt-user.model';

import { CustomerData } from '@app/shared/models/customers/customer-data.model';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnChanges {
  @Input() authUser: JwtUser;
  @Input() customer: CustomerData;
  @Input() toolbarVisible = true;
  @Input() toolbarMenuVisible = false;
  @Input() toolbarBackVisible = false;
  @Input() toolbarLinks: any[];

  @Output() openMenu = new EventEmitter<any>();
  @Output() back = new EventEmitter<any>();
  @Output() logout = new EventEmitter<any>();

  toolbarSearchControl: FormControl;

  toolbarLinksOptions: any[];

  constructor(private router: Router, private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.toolbarSearchControl = new FormControl('');

    this.toolbarSearchControl.valueChanges.pipe(
      filter(toolbarLink => toolbarLink && toolbarLink.path)
    ).subscribe((toolbarLink) => {
      this.router.navigate([toolbarLink.path]);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.toolbarLinks && this.toolbarLinks) {
      this.toolbarLinksOptions = [];
      this.toolbarLinks.forEach(link => {
        if (link.subTabs) {
          link.subTabs.forEach(subLink => {
            this.toolbarLinksOptions.push({
              label: this.translateService.instant(subLink.label),
              path: subLink.path
            });
          });
        }
      });
    }
  }

  onOpenMenu() {
    this.openMenu.emit();
  }

  onLogout() {
    this.logout.emit();
  }
}
